interface RoastersSearchBarProps {
  value: string;
  onChange: (value: string) => void;
}

export function RoastersSearchBar({ value, onChange }: RoastersSearchBarProps) {
  return (
    <div className="relative flex items-center">
      <div className="pointer-events-none absolute left-2.5 flex text-wolisho-brown/30">
        <svg
          width="15"
          height="15"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
        >
          <circle cx="11" cy="11" r="8" />
          <line x1="21" y1="21" x2="16.65" y2="16.65" />
        </svg>
      </div>
      <input
        type="text"
        value={value}
        onChange={(event) => onChange(event.target.value)}
        placeholder="Search roasters…"
        aria-label="Search roasters"
        data-testid="roasters-search"
        className="w-full rounded-lg border border-wolisho-brown/10 bg-wolisho-brown/[0.02] py-2.5 pl-8 pr-3 text-[13px] text-black outline-hidden"
      />
    </div>
  );
}
